import { render, staticRenderFns } from "./NoaAgentNavGroup.vue?vue&type=template&id=1a2e08c8&scoped=true"
import script from "./NoaAgentNavGroup.vue?vue&type=script&lang=js"
export * from "./NoaAgentNavGroup.vue?vue&type=script&lang=js"
import style0 from "./NoaAgentNavGroup.vue?vue&type=style&index=0&id=1a2e08c8&prod&lang=scss&scoped=true"
import style1 from "./NoaAgentNavGroup.vue?vue&type=style&index=1&id=1a2e08c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2e08c8",
  null
  
)

export default component.exports